/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";

// Import Components
import Loader from "../../../../components/Loader/Index";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithBulletPoint from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker";

// Import Redux
import {
  AddUserTag,
  getSpecificUser,
  getUsers,
  RemoveUserTag,
  deleteUser,
  resetPasswordCommunicate,
  assignRole,
  removeRole,
} from "../../../../redux/features/Settings/Management/Users";
import { getUserDetailsStateAction } from "../../../../redux/features/users/userDetails";

// Import Icons
import ICONS from "../../../../assets/Icons/index.js";

// Import Utils
import { toast } from "react-toastify";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import TEXT from "../../../../utils/globalText.js";
import CommonAssignTagPopup from "../../../../components/_utils/CommonPopups/CommonAssignTagPoppup/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup/index.jsx";
import {
  GlobalConfiguration,
  SettingsStatisticsConfiguration,
} from "../../../../utils/configurationProvider.js";

const UserDetails = ({ User_account_id, type }) => {
  const { id } = useParams();
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ensureAll, ensureAny] = useServiceChecker();
  const [ownerDetailData, setOwnerdetaildata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTagOpenPop, setSelectedTagOpenPop] = useState(false);
  const [newTags, setNewTags] = useState([]);
  const [existingTags, setExistingTags] = useState([]);
  const [existingRole, setExistingRole] = useState([]);
  const [AllTags, setAllTags] = useState([]);
  const getUserDetailsState = useSelector((state) => state?.getUserDetailsinfo);
  const { removeUserTagsLoading } = useSelector((state) => state.users);

  // switcher tabs states
  const [showUserDetails, setShowUserDetails] = useState(true);
  const [showUserRoles, setShowUserRoles] = useState(false);
  const [showUserFeatures, setShowUserFeatures] = useState(false);
  const [showUserServices, setShowUserServices] = useState(false);
  const [showUserTags, setShowUserTags] = useState(false);

  // modal states
  const [openDeleteUser, setOpenDeleteUser] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);

  const [showAssignRolesPopup, setShowAssignRolesPopup] = useState(false);

  //switcher tab animation states
  const [animationClass, setAnimationClass] = useState("");
  const [index, setIndex] = useState(
    showUserDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showUserRoles
        ? GlobalConfiguration?.lengthCheckOne
        : showUserFeatures
          ? GlobalConfiguration?.lengthCheckTwo
          : showUserServices
            ? GlobalConfiguration?.lengthCheckThree
            : showUserTags
              ? GlobalConfiguration?.lengthCheckFour
              : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );

  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const { specificUserData, specificUserLoading } = useSelector(
    (state) => state?.users,
  );

  const normalizeSearchValue = (text = "") =>
    text.toString().toLowerCase().replace(/[_-]+/g, "").replace(/\s+/g, "");

  let userDetailsData =
    specificUserData?.status === true
      ? specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
      : getUserDetailsState?.status &&
          id ===
            getUserDetailsState?.userInfo?.[GlobalConfiguration.lengthCheckZero]
              ?.id
        ? getUserDetailsState?.userInfo?.[GlobalConfiguration.lengthCheckZero]
        : undefined;

  useEffect(() => {
    if (
      loginid?.employees?.id !==
        (type === "User_details" ? User_account_id : id) &&
      !services?.includes("Admin") &&
      !!specificUserLoading === false &&
      isLoading === false
    ) {
      navigate("/feature_not_assigned", {
        replace: true,
        state: {
          unavailableService: "Admin",
        },
      });
    }
  }, [specificUserData]);

  useEffect(() => {
    if (!specificUserLoading && specificUserData) {
      let checkUserId =
        getUserDetailsState?.userInfo?.[GlobalConfiguration.lengthCheckZero]
          ?.id;

      if (
        userDetailsData === undefined &&
        id !== checkUserId &&
        getUserDetailsState?.status
      ) {
        navigate("*");
      } else if (
        specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
          ?.account_tags
      ) {
        const data = specificUserData?.employees?.[
          GlobalConfiguration.lengthCheckZero
        ]?.account_tags?.map((res) => {
          return { selected: true, value: res, type: "ownerTags" };
        });

        setNewTags(data);
      }
    }
  }, [
    userDetailsData,
    specificUserData,
    getUserDetailsState,
    specificUserLoading,
  ]);

  useEffect(() => {
    let getUserDetailsStateStorage = JSON.parse(
      sessionStorage.getItem("userDetailsInfostorage"),
    );

    dispatch(getUserDetailsStateAction(getUserDetailsStateStorage));
  }, []);

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedChipIndex(null);
  };

  function handleChipClick(id) {
    setSelectedChipIndex(id);
  }

  const toggleUserDetails = () => {
    setShowUserDetails(true);
    setShowUserRoles(false);
    setShowUserFeatures(false);
    setShowUserServices(false);
    setShowUserTags(false);
  };

  const toggleUserRoles = () => {
    setShowUserDetails(false);
    setShowUserRoles(true);
    setShowUserFeatures(false);
    setShowUserServices(false);
    setShowUserTags(false);
  };

  const toggleUserFeatures = () => {
    setShowUserDetails(false);
    setShowUserRoles(false);
    setShowUserFeatures(true);
    setShowUserServices(false);
    setShowUserTags(false);
  };

  const toggleUserServices = () => {
    setShowUserDetails(false);
    setShowUserRoles(false);
    setShowUserFeatures(false);
    setShowUserServices(true);
    setShowUserTags(false);
  };

  const toggleUserTags = () => {
    setShowUserDetails(false);
    setShowUserRoles(false);
    setShowUserFeatures(false);
    setShowUserServices(false);
    setShowUserTags(true);
  };

  const originDetailsEntries = [
    {
      heading: "Created by",
      content: userDetailsData?.created_by,
      type: "text",
    },
    {
      heading: "Created on",
      content: formatDateViewAll(userDetailsData?.created_on, true, true),
      type: "text",
    },
  ];

  const servicesMap = {};

  specificUserData?.user_services?.forEach((service) => {
    const header = service.service_header;

    if (!servicesMap[header]) {
      servicesMap[header] = {
        service_header: header,
        services: [],
      };
    }

    servicesMap[header].services.push({
      id: service.id,
      service_id: service.service_id,
      service_name: service.service_name,
      service_desc: service.service_desc,
    });
  });

  const userServices = Object.values(servicesMap);

  const featuresMap = specificUserData?.user_features;

  const rolesMap = specificUserData?.user_roles;

  const handleCloseModal = () => {
    setSelectedTagOpenPop(false);
  };
  const handleApply = () => {
    switch (selectedChipIndex) {
      case 1:
        navigate(`/settings/user_view_all/user_detail_page/edit_user/${id}`);
        break;

      case 2:
        setShowAssignRolesPopup(true);
        setIsEditModalOpen(false);
        break;

      default:
        break;
    }
  };

  const handleuserAll = async () => {
    setLoading(true);

    try {
      let response = await dispatch(
        getUsers({
          page_no: GlobalConfiguration.lengthCheckOne,
          page_size: GlobalConfiguration.searchMaxLength,
        }),
      );
      if (response?.payload?.status === true) {
        const data = response?.payload?.available_tags?.map((res) => {
          return { selected: true, value: res, type: "Available" };
        });

        setAllTags(data);
        setLoading(false);
      } else {
        setLoading(false);
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleAddTags = async (item) => {
    try {
      setLoading(true);
      CommonToast({
        text: "Assigning tag.",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      let response = await dispatch(
        AddUserTag({
          user_id: [id],
          tags:
            item?.type === "newAss" ? item?.data1 : item?.map((i) => i.value),
        }),
      );

      if (response?.payload?.status === true) {
        getOwnerDetaildata();
        setNewTags((prev) => [...prev, response?.meta?.arg?.tags]);
        toast.dismiss();
        CommonToast({
          text: "Tag assigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        handleuserAll();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleRemoveTags = async (item) => {
    if (removeUserTagsLoading) {
      setLoading(true);
    }

    try {
      CommonToast({
        text: "Unassigning tag.",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      setLoading(true);
      const response = await dispatch(
        RemoveUserTag({ user_id: [id], tags: item }),
      );

      if (response?.payload?.status === true) {
        getOwnerDetaildata();
        setNewTags((prevTags) => prevTags.filter((tag) => tag?.value !== item));
        handleuserAll();
        setLoading(false);
        toast.dismiss();
        CommonToast({
          text: "Tag unassigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error removing tag:", error);
    }
  };

  const getOwnerDetaildata = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getSpecificUser(type === "User_details" ? User_account_id : id),
      );
      setOwnerdetaildata(
        response?.payload?.employees?.[GlobalConfiguration.lengthCheckZero],
      );

      if (
        response?.payload?.employees?.[GlobalConfiguration.lengthCheckZero]
          ?.tags &&
        response?.payload?.employees?.[GlobalConfiguration.lengthCheckZero]
          ?.tags.length > GlobalConfiguration.lengthCheckZero
      ) {
        const data = response?.payload?.employees?.[
          GlobalConfiguration.lengthCheckZero
        ].tags?.map((res) => {
          return { selected: true, value: res, type: "ownerTags" };
        });

        setNewTags(data);
        setLoading(true);
      }

      setLoading(false);
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }

      if (response?.payload === undefined) {
        navigate("/feature_not_assigned");
      } else {
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const showToast = (message) => {
    CommonToast({
      text: message,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const closeDeleteUserModal = () => {
    setOpenDeleteUser(false);
  };

  const handleDeleteUser = async (id) => {
    showToast("Deleting user account");

    const response = await dispatch(
      deleteUser({ user_id: id, active_status: false }),
    );
    if (response?.payload?.status === true) {
      toast.dismiss();
      dispatch(getSpecificUser(id));
      setOpenDeleteUser(false);
    }
    setOpenDeleteUser(false);
  };

  const openResetPasswordModal = () => {
    setResetPassword(true);
  };

  const closeResetPasswordModal = () => {
    setResetPassword(false);
  };

  const handleContactUser = async (id) => {
    showToast("Sending temporary password");

    const response = await dispatch(
      resetPasswordCommunicate({
        user_id: id,
        entity_id: userDetailsData?.entity_id,
      }),
    );
    if (response?.payload?.status === true) {
      toast.dismiss();
      CommonToast({
        text: "Temporary password sent to user email.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } else {
      const message =
        response?.payload?.errors?.base?.[
          GlobalConfiguration.lengthCheckZero
        ] ||
        response?.payload?.response?.data?.errors?.user_unauthorized?.[
          GlobalConfiguration.lengthCheckZero
        ];
      toast.dismiss();
      CommonToast({
        text: message,
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--failed)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setResetPassword(false);
  };

  const handleEditUser = () => {
    setIsEditModalOpen(true);
  };

  const handleEditClick = (e) => {
    const isOwnProfile =
      sessionStorage.getItem("user_id") === userDetailsData?.user_id;
    const adminCheck = ensureAll(["Admin"]);

    if (adminCheck?.status) {
      handleEditUser();
      return;
    }

    if (isOwnProfile) {
      const empCheck = ensureAny(["EEmp"]);
      if (empCheck?.status) {
        handleEditUser();
      } else {
        navigate("/feature_not_assigned", {
          state: empCheck?.unavailableService,
        });
      }
      return;
    }

    navigate("/feature_not_assigned", {
      state: adminCheck?.unavailableService,
    });
  };

  const tagsDes = {
    searchPlaceholderDescription: "Search by tag",
    title7: "No assigned tags found.",
    title8: "No unassigned tags found.",
    title5: "Tag selected",
    title1: "Assigned tags",
    title2: "Unassigned tags",
  };

  const isAdmin = ensureAll(["Admin"]).status;
  const isCurrentlyLookingAtSelf =
    sessionStorage.getItem("user_id") === userDetailsData?.user_id;
  const chipsArray = [
    {
      text: "Name, Contact number, Email ID, Grade, Alias",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: ["Require approval."],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Roles",
      selected:
        selectedChipIndex ===
        SettingsStatisticsConfiguration.strokeWidthForLineGraph,
      disabled: !isAdmin,
      bulletPoint: ["Require approval."],
      hoverOption: "white",
      onClick: () =>
        handleChipClick(
          SettingsStatisticsConfiguration.strokeWidthForLineGraph,
        ),
    },
  ];

  const [newRoles, setNewRoles] = useState([]);
  const [AllRoles, setAllRoles] = useState([]);

  useEffect(() => {
    dispatch(getSpecificUser(type === "User_details" ? User_account_id : id));
    handleuserAll();
  }, [id]);

  useEffect(() => {
    if (!specificUserData) return;
    const assigned =
      specificUserData.user_roles?.map((r) => ({
        role_id: r.role_id,
        value: r.role_name,
        role_desc: r.role_desc,
        selected: true,
        type: "ownerTags",
      })) || [];

    const unassigned =
      specificUserData.unassigned_user_roles?.map((r) => ({
        role_id: r.role_id,
        value: r.role_name,
        role_desc: r.role_desc,
        selected: true,
        type: "Available",
      })) || [];

    if (!showAssignRolesPopup) {
      setNewRoles(assigned);
      setAllRoles(unassigned);
    }
  }, [specificUserData, showAssignRolesPopup]);

  const handleCloseAssignRoles = async () => {
    setShowAssignRolesPopup(false);
    setSelectedChipIndex(null);

    try {
      await dispatch(getSpecificUser(id)).unwrap();
    } catch (err) {
      console.error("Refresh after popup close failed:", err);
    }
  };
  const handleAddNewRoles = async (rolesFromPopup) => {
    await dispatch(
      assignRole({
        id,
        newRoles: rolesFromPopup.map((r) => ({ role_id: r.role_id })),
      }),
    ).unwrap();

    await dispatch(getSpecificUser(id)).unwrap();

    const addedRoles = rolesFromPopup.map((r) => {
      const original = AllRoles.find((a) => a.role_id === r.role_id);
      return {
        role_id: r.role_id,
        value: original ? original.value : r.value,
        role_desc: original ? original.role_desc : r.role_desc,
        selected: true,
        type: "ownerTags",
      };
    });

    setNewRoles((prev) => [...prev, ...addedRoles]);

    setAllRoles((prev) =>
      prev.filter(
        (r) => !rolesFromPopup.some((added) => added.role_id === r.role_id),
      ),
    );
  };

  const handleRemoveRoles = async (rolePayloadFromPopup) => {
    const incomingIds =
      (rolePayloadFromPopup || [])
        .map((it) => (it && it.role_id ? it.role_id : null))
        .filter(Boolean) || [];

    let rolesToRemove = [];

    if (incomingIds.length > GlobalConfiguration.lengthCheckZero) {
      rolesToRemove = newRoles.filter((r) => incomingIds.includes(r.role_id));
    } else {
      const normalizedIncoming = (rolePayloadFromPopup || []).map((n) =>
        normalizeSearchValue(n),
      );
      rolesToRemove = newRoles.filter((r) =>
        normalizedIncoming.includes(normalizeSearchValue(r.value)),
      );
    }

    for (const role of rolesToRemove) {
      try {
        await dispatch(
          removeRole({
            id,
            role_id: role.role_id,
          }),
        ).unwrap();
      } catch (err) {
        console.error("removeRole failed for", role.role_id, err);
      }
    }

    await dispatch(getSpecificUser(id)).unwrap();

    const removedIds = rolesToRemove.map((r) => r.role_id);

    setNewRoles((prev) => prev.filter((r) => !removedIds.includes(r.role_id)));

    setAllRoles((prev) => [
      ...prev,
      ...rolesToRemove.map((r) => ({
        ...r,
        selected: true,
        type: "Available",
      })),
    ]);
  };

  const canEditThisUser = () => {
    const isOwnProfile =
      sessionStorage.getItem("user_id") === userDetailsData?.user_id;

    if (ensureAll(["Admin"]).status) {
      return true;
    }

    if (isOwnProfile && ensureAny(["EEmp"]).status) {
      return true;
    }

    return false;
  };

  const rolesDes = {
    searchPlaceholderDescription: "Search by role name",
    headerDescription: "The user’s role within the entity.",
    title3: `Select roles and click "Assign" to link them to the user. `,
    title4: `Select roles and click "Unassign" to unlink them from the user.`,
    title5: "Roles selected",
    title7: "No assigned roles found.",
    title8: "No unassigned roles found.",
    title1: "Assigned roles",
    title2: "Unassigned roles",
    title6: " ",
    zeroValueDescription: `To assign roles, select from the list of unassigned roles and click "Assign"`,
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  return (
    <div
      className={`flex flex-col overflow-y-auto overflow-x-hidden bg-primary-bg ${type === "User_details" ? "" : "Qsmd:h-[calc(var(--full-height)-var(--navbar-breadcrumb-height))] h-full-height Qsmd:mt-[var(--navbar-breadcrumb-height)]"}  mt-margin-base`}
    >
      {selectedTagOpenPop && (
        <div
          className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
          onClick={handleCloseModal}
        >
          {
            <CommonAssignTagPopup
              headerTitle="Assign/Unassign tags:"
              closehandleFunction={handleCloseModal}
              closedisabledBgColor=""
              closebuttonRef=""
              closeimgColor=""
              newTags={newTags}
              handleAddTags={handleAddTags}
              existingTags={existingTags}
              setExistingTags={setExistingTags}
              handleRemoveTags={handleRemoveTags}
              setNewTags={setNewTags}
              ownerExistingTag={[]}
              AllTags={AllTags}
              setAllTags={setAllTags}
              loading={loading}
              setLoading={setLoading}
              getOwnerDetaildata={getOwnerDetaildata}
              ownerDetailData={[]}
              dummyUser={true}
              type={"ownerDetails"}
              users={[
                specificUserData?.employees?.[
                  GlobalConfiguration.lengthCheckZero
                ]?.first_name,
              ]}
              description={tagsDes}
            />
          }
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <EditCommonPopup
            headerTitle="Select the option you would like to edit:"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnOneHandleFunction={handleModalClose}
            btnTwoInActiveVariantNeeded={true}
            btnTwoHandleFunction={handleApply}
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={selectedChipIndex === null}
          />
        </div>
      )}

      {showAssignRolesPopup && (
        <div className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <CommonAssignTagPopup
            headerTitle="Assign/Unassign roles:"
            closehandleFunction={handleCloseAssignRoles}
            closedisabledBgColor=""
            closebuttonRef=""
            closeimgColor=""
            loading={loading}
            setLoading={setLoading}
            newTags={newRoles}
            AllTags={AllRoles}
            handleAddTags={handleAddNewRoles}
            existingTags={existingRole}
            setExistingTags={setExistingRole}
            handleRemoveTags={handleRemoveRoles}
            setNewTags={(arr) => {
              const mapped = arr.map((a) => {
                const original =
                  newRoles.find((nr) => nr.role_id === a.role_id) ||
                  AllRoles.find((ar) => ar.role_id === a.role_id);
                return original ? { ...original, selected: a.selected } : a;
              });
              setNewRoles(mapped);
            }}
            ownerExistingTag={[]}
            setAllTags={(arr) => {
              const mapped = arr.map((a) => {
                const original =
                  AllRoles.find((ar) => ar.role_id === a.role_id) ||
                  newRoles.find((nr) => nr.role_id === a.role_id);
                return original ? { ...original, selected: a.selected } : a;
              });
              setAllRoles(mapped);
            }}
            getOwnerDetaildata={getOwnerDetaildata}
            ownerDetailData={[]}
            dummyUser={true}
            type={"ownerDetails"}
            users={true}
            isCapitalWords={true}
            typeForSpaces={"privateTxn"}
            description={rolesDes}
          />
        </div>
      )}
      {openDeleteUser && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle="Delete user"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle={`Are you sure you want to delete ${
              userDetailsData?.first_name + " " + userDetailsData?.last_name
            } account?`}
            secondHeaderFontWeight="normal"
            subtext="User will lose all access and account will be permanently deleted."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => closeDeleteUserModal()}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Delete"
            btnTwoBtnType="button"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="white"
            btnTwoHandleFunction={() => handleDeleteUser(userDetailsData?.id)}
          />
        </div>
      )}
      {resetPassword && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <SmallPopupWithBulletPoint
            headerTitle={"Reset password"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            bulletPoints={[
              "The user will be immediately logged out of all active devices.",
              "An email will be sent to the user with temporary password and will be prompted to create a new password at login.",
            ]}
            isTextInputField={false}
            btnOneText="Cancel"
            btnOneHandleFunction={() => closeResetPasswordModal()}
            btnOneOutLineColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText={"Reset"}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
            btnTwoHandleFunction={() =>
              handleContactUser(userDetailsData?.user_id)
            }
          />
        </div>
      )}
      {specificUserLoading ? (
        <div className="loader-container m-auto justify-center items-center flex">
          <Loader />
        </div>
      ) : (
        <>
          <div className="hidden  bg-primary-nav"></div>
          {/* Responsive page header */}
          <div
            className={`Qsmd:hidden ${type === "User_details" ? "hidden" : "block"} fixed w-width-full  z-z-index-fixed-ui shadow-box-shadow-bottom`}
          >
            <TopNavComponent
              handleBack={(e) => navigate(-1)}
              topNavHeader={"Users"}
              topNavSubText="View detail"
              isFormattingNotRequired={true}
            />
          </div>
          {/* -------------------- */}
          <div className="w-width-full bg-primary-nav">
            <div className="max-w-tab-width-normal mx-auto Qsmd:px-padding-md Qlg:px-padding-base px-padding-md">
              <div
                className={`flex flex-col  Qsmd:flex-row justify-between border-b border-solid border-primary-bg ${type === "User_details" ? "" : " pt-[calc(var(--padding-lg)+var(--padding-xl))] Qsmd:pt-padding-base"}`}
              >
                <div className="flex flex-1 py-padding-md pr-padding-md Qmd:pl-padding-md Qsmd:pl-padding-base px-padding-base ">
                  <TitleSubtitlePair
                    title={
                      userDetailsData?.first_name +
                      " " +
                      (userDetailsData?.last_name ?? "")
                    }
                    subtitle={"User name"}
                    titleColor={"text-primary"}
                    isBold={false}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
                <div className="hidden Qsmd:flex border-r border-solid border-primary-bg my-margin-md"></div>
                <div className="w-width-full Qsmd:w-tl-width-2 flex Qsmd:flex-row flex-col justify-between border-t-border border-t-primary-bg Qsmd:border-none">
                  <div className="flex p-padding-md w-width-full px-padding-base Qmd:p-padding-md">
                    <TitleSubtitlePair
                      title={userDetailsData?.user_id}
                      subtitle={"User ID"}
                      titleColor={"text-primary"}
                      isBold={false}
                      variant="md"
                      textAlign={"left"}
                    />
                  </div>
                  <div className="hidden Qsmd:flex border-r border-solid border-primary-bg my-margin-md"></div>
                  <div className="Qsmd:hidden border-b border-solid border-primary-bg"></div>
                  <div className="flex p-padding-md w-width-full px-padding-base Qmd:p-padding-md">
                    <TitleSubtitlePair
                      title={userDetailsData?.alias_name || "N/A"}
                      subtitle={"Alias"}
                      titleColor={"text-primary"}
                      isBold={false}
                      variant="md"
                      textAlign={"left"}
                    />
                  </div>

                  <div className="hidden Qsmd:flex">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Edit <br /> user
                        </>
                      }
                      isDisabled={
                        type === "User_details" ? true : !canEditThisUser()
                      }
                      handleFunction={() => {
                        if (type !== "User_details") {
                          handleEditClick();
                        } else {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                        }
                      }}
                      icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      hoverOption="white"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col Qsmd:flex-row justify-between border-b border-solid border-primary-bg">
                <div className="flex flex-1 py-padding-md Qmd:px-padding-md Qsmd:px-padding-base px-padding-base">
                  <TitleSubtitlePair
                    title={userDetailsData?.mob_no}
                    subtitle={"Contact number"}
                    titleColor={"text-primary"}
                    isBold={false}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
                <div className="w-width-full Qsmd:w-tl-width-2 flex Qsmd:flex-row flex-col justify-between border-t-border border-t-primary-bg Qsmd:border-none">
                  <div className="hidden Qsmd:flex border-r border-solid border-primary-bg my-margin-md"></div>
                  <div className="flex p-padding-md w-width-full px-padding-base Qmd:p-padding-md">
                    <TitleSubtitlePair
                      title={userDetailsData?.email_id}
                      subtitle={"Email ID"}
                      titleColor={"text-primary"}
                      isBold={false}
                      variant="md"
                      textAlign={"left"}
                    />
                  </div>
                  {/* </div> */}
                  <div className="hidden Qsmd:flex">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Reset <br /> password
                        </>
                      }
                      handleFunction={() => {
                        if (type === "User_details") {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                        } else {
                          const serviceCheck = ensureAll(["Admin"]);
                          if (serviceCheck?.status) {
                            openResetPasswordModal();
                          } else {
                            navigate("/feature_not_assigned", {
                              state: serviceCheck.unavailableService,
                            });
                          }
                        }
                      }}
                      icon={ICONS?.AUTO_GENERATE_PASSWORD}
                      isDisabled={
                        type === "User_details"
                          ? true
                          : !ensureAll(["Admin"]).status
                      }
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      hoverOption="white"
                    />
                  </div>
                  {/* <div className="hidden Qsmd:flex py-padding-button-l bg-primary-nav-act">
                    <div className="flex-grow border-r border-solid border-primary-bg"></div>
                  </div> */}
                </div>
              </div>

              <div className="flex flex-col Qsmd:flex-row justify-between">
                <div className="flex-1 py-padding-md Qmd:px-padding-md Qsmd:px-padding-base px-padding-base">
                  <TitleSubtitlePair
                    title={
                      userDetailsData?.active_status === "Y"
                        ? "Active"
                        : "Inactive"
                    }
                    subtitle={"Status"}
                    titleColor={
                      userDetailsData?.active_status === "Y"
                        ? "settled"
                        : "failed"
                    }
                    isBold={true}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
                <div className="w-width-full Qsmd:w-tl-width-2 flex Qsmd:flex-row flex-col justify-between border-t-border border-t-primary-bg Qsmd:border-none">
                  <div className="hidden Qsmd:flex border-r border-solid border-primary-bg my-margin-md"></div>
                  <div className="flex p-padding-md w-width-full px-padding-base Qmd:p-padding-md">
                    <TitleSubtitlePair
                      title={userDetailsData?.grade}
                      subtitle={"Grade"}
                      titleColor={"text-primary"}
                      isBold={false}
                      variant="md"
                      textAlign={"left"}
                    />
                  </div>
                  <div className="hidden Qsmd:flex">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Delete <br /> user
                        </>
                      }
                      handleFunction={() => {
                        // const serviceCheck = ensureAll(["Admin", "EEmp"]);
                        // if (
                        //   serviceCheck.status &&
                        //   userDetailsData?.active_status === "Y"
                        // ) {
                        //   openDeleteUserModal();
                        // }
                        if (type === "User_details") {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                        } else {
                          CommonToast({
                            text: "Feature coming soon",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--coming-soon)",
                            btnProps: {
                              isDisabled: false,
                              enabledTextColor: "var(--text-primary)",
                              enabledBgColor: "var(--primary-bg)",
                            },
                          });
                        }
                      }}
                      icon={ICONS?.DELETE_WITH_WHITE_CIRCLE}
                      isDisabled={
                        // !ensureAll(["Admin", "EEmp"]).status ||
                        // userDetailsData?.active_status === "N"
                        true
                      }
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      hoverOption="white"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Responsive Quick Actions  */}
          <div className="block Qsmd:hidden mt-margin-md bg-primary-nav-act">
            <p className="bg-primary-card h-tertiary-btn-height text-sm font-semibold text-text-primary pl-padding-md flex items-center">
              Quick Actions
            </p>

            <div className="flex flex-row w-width-full bg-primary-nav-act">
              <div className="flex w-width-full items-center justify-center">
                <TopNavSmallButton
                  btnText={
                    <>
                      Edit <br /> user
                    </>
                  }
                  handleFunction={() => {
                    if (type !== "User_details") {
                      handleEditClick();
                    } else {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                    }
                  }}
                  icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                  isDisabled={
                    type === "User_details" ? true : !canEditThisUser()
                  }
                  enabledBgColor={"var(--primary-nav-act)"}
                  enabledTextColor={"var(--text-primary)"}
                  fullWidthRequired={true}
                  hoverOption="white"
                />
              </div>
              <div className="border-r border-solid border-primary-bg my-margin-sm"></div>
              <div className="flex w-width-full items-center justify-center">
                <TopNavSmallButton
                  btnText={
                    <>
                      Reset <br /> password
                    </>
                  }
                  handleFunction={() => {
                    if (type === "User_details") {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                    } else {
                      const serviceCheck = ensureAll(["Admin"]);
                      if (serviceCheck?.status) {
                        openResetPasswordModal();
                      } else {
                        navigate("/feature_not_assigned", {
                          state: serviceCheck.unavailableService,
                        });
                      }
                    }
                  }}
                  icon={ICONS?.AUTO_GENERATE_PASSWORD}
                  isDisabled={
                    type === "User_details"
                      ? true
                      : !ensureAll(["Admin"]).status
                  }
                  enabledBgColor={"var(--primary-nav-act)"}
                  enabledTextColor={"var(--text-primary)"}
                  fullWidthRequired={true}
                  hoverOption="white"
                />
              </div>
            </div>
            <div className="mx-margin-md border-b border-solid border-primary-bg"></div>
            <div className="flex items-center justify-center w-width-full bg-primary-nav-act">
              <TopNavSmallButton
                btnText={
                  <>
                    Delete <br /> user
                  </>
                }
                handleFunction={() => {
                  // const serviceCheck = ensureAll(["Admin", "EEmp"]);
                  // if (
                  //   serviceCheck.status &&
                  //   userDetailsData?.active_status === "Y"
                  // ) {
                  //   openDeleteUserModal();
                  // }
                  if (type === "User_details") {
                    CommonToast({
                      text: "Action restricted in popup mode.",
                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                      variant: "var(--error)",
                    });
                  } else {
                    CommonToast({
                      text: "Feature coming soon",
                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                      variant: "var(--coming-soon)",
                      btnProps: {
                        isDisabled: false,
                        enabledTextColor: "var(--text-primary)",
                        enabledBgColor: "var(--primary-bg)",
                      },
                    });
                  }
                }}
                icon={ICONS?.DELETE_WITH_WHITE_CIRCLE}
                isDisabled={
                  // !ensureAll(["Admin", "EEmp"]).status ||
                  // userDetailsData?.active_status === "N"
                  true
                }
                enabledBgColor={"var(--primary-nav-act)"}
                enabledTextColor={"var(--text-primary)"}
                hoverOption="white"
              />
            </div>
          </div>
          {/* --------------------------*/}

          {/* Switcher Tab & Additional Details of User */}
          <div className="w-full">
            <div className="m-auto max-w-tab-width-normal">
              <div className="flex pt-padding-md px-padding-md Qlg:px-padding-base">
                <div className="flex gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden overflow-x-scroll no-scrollbar">
                  <SwitcherTabs
                    tabs={[
                      {
                        label: "Details",
                        key: "details",
                        handler: toggleUserDetails,
                      },
                      {
                        label: "Roles",
                        key: "roles",
                        handler: toggleUserRoles,
                      },
                      {
                        label: "Features",
                        key: "features",
                        handler: toggleUserFeatures,
                      },
                      {
                        label: "Services",
                        key: "services",
                        handler: toggleUserServices,
                      },
                      {
                        label: "Tags",
                        key: "tags",
                        handler: toggleUserTags,
                      },
                    ]}
                    initialActiveTab={
                      showUserRoles
                        ? "roles"
                        : showUserFeatures
                          ? "features"
                          : showUserServices
                            ? "services"
                            : showUserTags
                              ? "tags"
                              : "details"
                    }
                    setIndex={setIndex}
                  />
                </div>
              </div>
              <div className="relative">
                {index === GlobalConfiguration?.lengthCheckZero && (
                  <div className={animationClass}>
                    <div
                      key={ownerDetailData?.id}
                      className="flex flex-col Qsmd:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md"
                    >
                      <CommonDetailCard
                        cardTitle="Origin Details"
                        numCols={GlobalConfiguration?.lengthCheckOne}
                        variant="third"
                        entries={originDetailsEntries}
                      />
                    </div>
                  </div>
                )}
                {index === GlobalConfiguration?.lengthCheckOne &&
                  (rolesMap?.length > GlobalConfiguration?.lengthCheckZero ? (
                    <div className={animationClass}>
                      <div className="flex flex-row flex-wrap my-margin-md px-padding-md lg:px-padding-base gap-gap-md">
                        {rolesMap?.map((roleInfo) => {
                          return (
                            <>
                              <CardContainer
                                key={roleInfo?.role_id}
                                context={roleInfo}
                                isNoHoverRequired={false}
                                isDisabled={false}
                                isSelected={false}
                                onClickHandler={() => {
                                  navigate(
                                    `/settings/role_view_all/role_detail_page/${roleInfo?.role_id}`,
                                  );
                                }}
                              >
                                <card-body>
                                  <TextWithIcon
                                    type={"text"}
                                    fontWeight={"normal"}
                                    text={roleInfo?.role_name}
                                    subText={"Role name"}
                                    textColor={"var(--text-primary)"}
                                  />
                                  <TextWithIcon
                                    type={"text"}
                                    fontWeight={"normal"}
                                    text={roleInfo?.role_desc}
                                    subText={"Role description"}
                                    textColor={"var(--text-primary)"}
                                  />
                                </card-body>
                              </CardContainer>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <div className={animationClass}>
                      <div className="mt-margin-md pb-padding-md">
                        <CommonContainerCard header="Services">
                          <div className="flex flex-row flex-wrap gap-gap-sm">
                            <p className="text-font-sm text-text-primary">
                              No roles assigned
                            </p>
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  ))}
                {index === GlobalConfiguration?.lengthCheckTwo &&
                  (featuresMap?.length >
                  GlobalConfiguration?.lengthCheckZero ? (
                    <div className={animationClass}>
                      <div className="flex flex-row flex-wrap my-margin-md px-padding-md lg:px-padding-base gap-gap-md">
                        {featuresMap?.map((featureInfo) => {
                          return (
                            <>
                              <CardContainer
                                key={featureInfo?.feature_id}
                                context={featureInfo}
                                isNoHoverRequired={false}
                                isDisabled={false}
                                isSelected={false}
                                onClickHandler={() => {
                                  navigate(
                                    `/settings/feature_view_all/feature_detail_page/${featureInfo?.feature_id}`,
                                  );
                                }}
                              >
                                <card-body>
                                  <TextWithIcon
                                    type={"text"}
                                    fontWeight={"normal"}
                                    text={featureInfo?.feature_name}
                                    subText={"Feature name"}
                                    textColor={"var(--text-primary)"}
                                  />
                                  <TextWithIcon
                                    type={"text"}
                                    fontWeight={"normal"}
                                    text={featureInfo?.feature_description}
                                    subText={"Feature description"}
                                    textColor={"var(--text-primary)"}
                                  />
                                </card-body>
                              </CardContainer>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <div className={animationClass}>
                      <div className="mt-margin-md pb-padding-md">
                        <CommonContainerCard header="Services">
                          <div className="flex flex-row flex-wrap gap-gap-sm">
                            <p className="text-font-sm text-text-primary">
                              No features assigned
                            </p>
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  ))}
                {index === GlobalConfiguration.lengthCheckThree &&
                  (userServices?.length >
                  GlobalConfiguration?.lengthCheckZero ? (
                    <div className={animationClass}>
                      <div className="flex flex-col py-padding-md gap-gap-sm px-padding-md Qlg:px-padding-base">
                        {userServices?.map((serviceInfo) => (
                          <div key={serviceInfo?.service_header}>
                            <p className="bg-primary-nav-act w-width-full py-padding-sm flex items-center justify-start px-padding-md text-text-primary font-semibold rounded-border-radius-md lg:mx-padding-base">
                              {serviceInfo?.service_header &&
                                serviceInfo.service_header
                                  .charAt(GlobalConfiguration?.lengthCheckZero)
                                  .toUpperCase() +
                                  serviceInfo.service_header.slice(
                                    GlobalConfiguration?.lengthCheckOne,
                                  )}
                            </p>
                            <div className="flex flex-wrap gap-gap-sm pt-padding-sm">
                              {serviceInfo?.services.map((service) => (
                                <CardContainer
                                  key={service?.id}
                                  context={service}
                                  isNoHoverRequired={false}
                                  isDisabled={false}
                                  isSelected={false}
                                  onClickHandler={() => {
                                    navigate(
                                      `/settings/service_view_all/service_detail_page/${service?.id}`,
                                    );
                                  }}
                                >
                                  <card-body>
                                    <TextWithIcon
                                      type={"text"}
                                      fontWeight={"normal"}
                                      text={service?.service_name}
                                      subText={"Service name"}
                                      textColor={"var(--text-primary)"}
                                    />
                                    <TextWithIcon
                                      type={"text"}
                                      fontWeight={"normal"}
                                      text={service?.service_desc}
                                      subText={"Service description"}
                                      textColor={"var(--text-primary)"}
                                    />
                                  </card-body>
                                </CardContainer>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className={animationClass}>
                      <div className="mt-margin-md pb-padding-md">
                        <CommonContainerCard header="Services">
                          <div className="flex flex-row flex-wrap gap-gap-sm">
                            <p className="text-font-sm text-text-primary">
                              No services assigned
                            </p>
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  ))}

                {index === GlobalConfiguration.lengthCheckFour && (
                  <div className={animationClass}>
                    <div className="mt-margin-md pb-padding-md">
                      <CommonContainerCard
                        header="Tags"
                        subheader={TEXT?.TAG_INSTRUCTION}
                        icon={
                          "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                        }
                        iconIsDisabled={
                          type === "User_details"
                            ? true
                            : !(!isCurrentlyLookingAtSelf || !isAdmin)
                        }
                        handleFunction={() => {
                          if (type === "User_details") {
                            CommonToast({
                              text: "Action restricted in popup mode.",
                              icon: ICONS?.ERROR_WHITE_CIRCLE,
                              variant: "var(--error)",
                            });
                          } else {
                            if (!(!isCurrentlyLookingAtSelf || !isAdmin))
                              return;
                            if (
                              !services?.includes("CTag") &&
                              !services?.includes("DTag")
                            ) {
                              navigate("/feature_not_assigned");
                            } else {
                              setSelectedTagOpenPop(true);
                            }
                          }
                        }}
                      >
                        <div className="flex flex-row flex-wrap gap-gap-sm">
                          {specificUserData?.employees?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.account_tags?.length >
                          GlobalConfiguration.lengthCheckZero ? (
                            specificUserData?.employees?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.account_tags?.map((tag) => {
                              return (
                                <>
                                  <div className="w-auto">
                                    <Chips
                                      txtChip={tag}
                                      enabledBgColor="var(--primary-nav)"
                                      enabledTextColor="var(--text-primary)"
                                      fullWidthRequired
                                    />
                                  </div>
                                </>
                              );
                            })
                          ) : (
                            <p className="text-font-sm text-text-primary">
                              {TEXT?.NO_TAGS_ASSIGNED}
                            </p>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserDetails;
